import mainImg from "../../../assets/grey-slimbox.webp";
import thumb1 from "../../../assets/grey-slimbox-thumb-one.webp";
import thumb2 from "../../../assets/grey-slimbox-thumb-two.webp";

import mainImg1 from "../../../assets/matt-black-slimtandam-box -thaumb.png";
import thumb3 from "../../../assets//matt-black-slimtandam-box -thaumb-two.png";
import thumb4 from "../../../assets//matt-black-slimtandam-box -thaumb-one.png";


import mainImg2 from "../../../assets/silver-slim-tandem-box500mm.webp";
import thumb5 from "../../../assets/silvre-slim-tandem-box-thumb-one.png";
import thumb6 from "../../../assets/silvre-slim-tandem-box-thumb-two.webp";


import mainImg3 from "../../../assets/slimbox-with-gallry.webp";
import thumb7 from "../../../assets/slimbox-with-gallry.webp";
import thumb8 from "../../../assets/slimbox-with-gallry.webp";

import mainImg4 from "../../../assets/glass-tamdom.webp";
import thumb9 from "../../../assets/glass-tamdom.webp";
import thumb10 from "../../../assets/glass-tamdom.webp";



import mainImg5 from "../../../assets/dark-grey-tandem-box.webp";
import thumb11 from "../../../assets/dark-grey-tandem-box-thumb-one.webp";
import thumb12 from "../../../assets/dark-grey-tandem-box-thumb-one.webp";


import mainImg6 from "../../../assets/push-opne-quadro.webp";
import thumb13 from "../../../assets/push-opne-quadro.webp";
import thumb14 from "../../../assets/push-opne-quadro.webp";

import mainImg7 from "../../../assets/3d-quadra.webp";
import thumb15 from "../../../assets/3d-quadra.webp";
import thumb16 from "../../../assets/3d-quadra.webp";



export const slimBoxes = [
  {
  code: "SM-01",
  name: "GREY SLIM BOX 500mm",
  category: "slim-box",

  mainImage: mainImg,

  thumbnails: [thumb1, thumb2],

  short:
    "Grey Slim Box 500mm is a compact and modern drawer storage solution designed for modular kitchens and furniture. Its slim design helps maximize drawer space while keeping items neatly organized. The premium grey finish adds a stylish and elegant touch to interiors.",

  features: [
    "84mm slim design for compact drawers",
    "Premium grey finish for modern look",
    "Smooth drawer integration",
    "Strong and durable construction",
    "Perfect for organizing small items",
  ],

  // ✅ VIDEO (SHORTS LINK ADDED)
  video: "https://www.youtube.com/embed/ikjQKXTpNhg",

  price: "₹2558",
  oldPrice: "₹2699",

  sku: "7159-7426",
  stock: "In Stock",

  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Grey%20Slim%20Box%2084mm%20Inquiry",

  // ✅ ADDITIONAL INFO (TABLE KE LIYE)
  specifications: [
    { label: "Product Type", value: "Slim Box Drawer System" },
    { label: "Height", value: "84mm" },
    { label: "Material", value: "Metal" },
    { label: "Finish", value: "Grey" },
    { label: "Usage", value: "Kitchen / Furniture Drawer" },
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "Grey Slim Box",
      code: "SM-01",
      size: "84mm",
      finish: "Grey",
    },
    {
      item: "Grey Slim Box",
      code: "SM-01",
      size: "116mm",
      finish: "Grey",
    },
    {
      item: "Grey Slim Box",
      code: "SM-01",
      size: "166mm",
      finish: "Grey",
    },
    {
      item: "Grey Slim Box",
      code: "SM-01",
      size: "196mm",
      finish: "Grey",
    },

  ],

  faq: [
    {
      question: "What is Grey Slim Box 84mm?",
      answer:
        "Grey Slim Box 84mm is a modular drawer storage system designed to organize items efficiently in slim drawer spaces.",
    },
    {
      question: "Where is it used?",
      answer:
        "It is used in kitchen drawers, wardrobes, and modular furniture for organizing small items.",
    },
    {
      question: "What are its advantages?",
      answer:
        "It saves space, improves organization, and provides a modern look with smooth functionality.",
    },
    {
      question: "What can be stored in it?",
      answer:
        "You can store cutlery, tools, stationery, or small household items.",
    },
  ],
},
{
  code: "SM-02",
  name: "MATT BLACK SLIM Tandem BOX",
  category: "slim-box",

  mainImage: mainImg1,
  thumbnails: [thumb3, thumb4],

  short:
    "Matt Black Slim Box is a premium drawer system designed for modern modular kitchens and furniture. Its sleek matte black finish gives a bold and elegant look, while the slim design helps maximize drawer space. The smooth sliding mechanism ensures effortless operation and organized storage of daily-use items.",

  features: [
    "Premium matte black finish for modern look",
    "Slim drawer design for better space utilization",
    "Smooth and silent sliding mechanism",
    "Strong and durable metal construction",
    "Suitable for cutlery and small item storage",
    "Perfect for modular kitchen drawers"
  ],

  // ✅ VIDEO (EMBED LINK SAME AS SM-01)
  video: "https://www.youtube.com/embed/ikjQKXTpNhg",

  // ✅ PRICE
  price: "₹1836",
  oldPrice: "₹1900",

  sku: "7616-7618",
  stock: "In Stock",

  // ✅ BUTTONS
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Matt%20Black%20Slimbox%20Inquiry",

  // ✅ ADDITIONAL INFO (TABLE)
  specifications: [
    { label: "Height", value: "84mm" },
    { label: "Material", value: "Metal" },
    { label: "Finish", value: "Matt Black" },
    { label: "Usage", value: "Drawer Storage" },
    { label: "Installation", value: "Drawer System" },
    { label: "Type", value: "Slim Box Drawer" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "MATT BLACK SLIMBOX",
      code: "7616",
      size: "84mm",
      finish: "Matt Black"
    },
     {
      item: "MATT BLACK SLIMBOX",
      code: "7617",
      size: "166mm",
      finish: "Matt Black"
    },
     {
      item: "MATT BLACK SLIMBOX",
      code: "7618",
      size: "167mm",
      finish: "Matt Black"
    },
   
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is a Matt Black Slim Box?",
      answer:
        "Matt Black Slim Box is a modular drawer system designed for slim drawers, offering organized storage with a modern matte black finish."
    },
    {
      question: "Where is it used?",
      answer:
        "It is used in kitchen drawers, wardrobes, and modular furniture for organizing small items."
    },
    {
      question: "What are its advantages?",
      answer:
        "It improves drawer aesthetics, saves space, provides smooth movement, and keeps items organized."
    },
    {
      question: "What items can be stored?",
      answer:
        "It is ideal for storing cutlery, utensils, stationery, and small accessories."
    }
  ]
},



  {
  code: "SM-03",
  name: "SILVER SLIM TANDEM BOX 500mm",
  category: "slim-box",

  mainImage: mainImg2,
  thumbnails: [thumb5, thumb6],

  short:
    "Silver Slim Tandem Box 500mm is a premium drawer system designed for modular kitchens and furniture. Its elegant silver finish enhances the overall cabinet look, while the slim design maximizes storage space. The tandem sliding mechanism ensures smooth, silent, and controlled drawer movement, making it ideal for daily use.",

  features: [
    "Elegant silver finish for modern look",
    "500mm depth suitable for standard drawers",
    "Smooth and silent sliding mechanism",
    "Strong and durable metal construction",
    "High load-bearing capacity",
    "Slim design for better space utilization"
  ],

  // ✅ VIDEO (SAME EMBED)
  video: "https://www.youtube.com/embed/qqayGzUzTVA",

  // ✅ PRICE
  price: "₹1822",
  oldPrice: "₹2000",

  sku: "7619-7621",
  stock: "In Stock",

  // ✅ BUTTONS
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Silver%20Slim%20Tandem%20Box%20500mm%20Inquiry",

  // ✅ ADDITIONAL INFO (TABLE)
  specifications: [
    { label: "Length", value: "500mm" },
    { label: "Material", value: "Metal" },
    { label: "Finish", value: "Silver" },
    { label: "Usage", value: "Drawer Storage" },
    { label: "Installation", value: "Drawer System" },
    { label: "Type", value: "Slim Tandem Box" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "SILVER SLIM TANDEM BOX 500mm",
      code: "7619",
      size: "84mm",
      finish: "Matt Black"
    },
     {
      item: "SILVER SLIM TANDEM BOX 500mm",
      code: "7620",
      size: "166mm",
      finish: "Matt Black"
    },
     {
      item: "SILVER SLIM TANDEM BOX 500mm",
      code: "7621",
      size: "167mm",
      finish: "Matt Black"
    },
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is Silver Slim Tandem Box 500mm?",
      answer:
        "It is a modular drawer system designed for slim drawers, offering organized storage with a durable silver finish."
    },
    {
      question: "Where is it used?",
      answer:
        "It is used in kitchen drawers, wardrobes, and modular furniture for organizing small items."
    },
    {
      question: "What are its advantages?",
      answer:
        "It maximizes drawer space, ensures smooth sliding, keeps items organized, and enhances drawer aesthetics."
    },
    {
      question: "What items can be stored?",
      answer:
        "It is ideal for storing cutlery, utensils, kitchen tools, and small accessories."
    }
  ]
},


   {
  code: "SM-04",
  name: "SLIMLINE TANDEM DRAWER BOX SYSTEM WITH GALLERY",
  category: "slim-box",

  mainImage: mainImg3,
  thumbnails: [thumb7, thumb8],

  short:
    "Slimline Tandem Drawer Box System with Gallery is a premium drawer solution designed for modular kitchens and furniture. It features slim metal sides with an additional gallery railing that provides extra height and support, keeping stored items secure. The tandem sliding mechanism ensures smooth, silent, and controlled drawer movement for daily use.",

  features: [
    "Slim metal sides with gallery railing for extra support",
    "Prevents items from falling during drawer movement",
    "Smooth and silent tandem sliding mechanism",
    "Strong and durable metal construction",
    "Ideal for storing utensils, containers, and kitchen essentials",
    "Better space utilization with slim side profile"
  ],

  // ✅ VIDEO (SAME EMBED)
  video: "https://youtube.com/shorts/fcURZWugznI?si=53jAicW8Tdt2FLf9",

  // ✅ PRICE
  price: "₹349",
  oldPrice: "₹500",

  sku: "7628",
  stock: "In Stock",

  // ✅ BUTTONS
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Slimline%20Tandem%20Drawer%20Box%20System%20with%20Gallery%20Inquiry",

  // ✅ ADDITIONAL INFO (TABLE)
  specifications: [
    { label: "Type", value: "Tandem Drawer Box with Gallery" },
    { label: "Material", value: "Metal" },
    { label: "Finish", value: "Grey" },
    { label: "Usage", value: "Drawer Storage" },
    { label: "Extension", value: "Full Extension" },
    { label: "Installation", value: "Drawer System" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "SLIMLINE TANDEM DRAWER BOX",
      code: "7628",
      size: "500mm",
      finish: "Grey"
    },
    
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is the Slimline Tandem Drawer Box System with Gallery?",
      answer:
        "It is a modular drawer system with an additional gallery railing that provides extra support and organized storage."
    },
    {
      question: "Where is it used?",
      answer:
        "It is used in kitchen drawers, wardrobes, and modular furniture for efficient storage."
    },
    {
      question: "What are its advantages?",
      answer:
        "It offers smooth sliding, prevents items from falling, improves organization, and enhances drawer aesthetics."
    },
    {
      question: "What items can be stored?",
      answer:
        "It is ideal for storing utensils, containers, kitchen tools, and daily-use items."
    }
  ]
},


 {
  code: "SM-05",
  name: "GLASS TANDEM BOX",
  category: "slim-box",

  mainImage: mainImg4,
  thumbnails: [thumb9, thumb10],

  short:
    "Glass Tandem Box is a modern drawer system designed for modular kitchens and storage cabinets. It features slim metal sides with elegant toughened glass panels that enhance visibility and add a premium look. The tandem sliding mechanism ensures smooth, silent, and controlled drawer movement for daily use.",

  features: [
    "Toughened glass sides for clear visibility",
    "Slim metal frame with premium glass finish",
    "Smooth and silent tandem sliding mechanism",
    "Prevents items from falling during movement",
    "Ideal for utensils, containers, and kitchen essentials",
    "Perfect for deep drawers and organized storage"
  ],

  // ✅ VIDEO (SAME EMBED)
  video: "https://www.youtube.com/embed/Q_mmokwRQDE",

  // ✅ PRICE
  price: "₹2969",
  oldPrice: "₹3400",

  sku: "7443",
  stock: "In Stock",

  // ✅ BUTTONS
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Glass%20Tandem%20Box%20Inquiry",

  // ✅ ADDITIONAL INFO (TABLE)
  specifications: [
    { label: "Type", value: "Glass Tandem Drawer Box" },
    { label: "Material", value: "Metal + Toughened Glass" },
    { label: "Finish", value: "Silver / Transparent Glass" },
    { label: "Usage", value: "Drawer Storage" },
    { label: "Extension", value: "Full Extension" },
    { label: "Installation", value: "Drawer System" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "GLASS TANDEM BOX",
      code: "7443",
      size: "84mm",
      finish: " Glass"
    },
    {
      item: "GLASS TANDEM BOX",
      code: "7719",
      size: "166mm",
      finish: " Glass"
    },
    {
      item: "GLASS TANDEM BOX",
      code: "7444",
      size: "167mm",
      finish: " Glass"
    },
    {
      item: "GLASS TANDEM BOX",
      code: "7445",
      size: "196mm",
      finish: " Glass"
    },
    
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is a Glass Tandem Box?",
      answer:
        "It is a modular drawer system with glass panels that provide visibility and organized storage."
    },
    {
      question: "Where is it used?",
      answer:
        "It is used in kitchen drawers, cabinets, and modular furniture for storing items neatly."
    },
    {
      question: "What are its advantages?",
      answer:
        "It offers smooth sliding, modern appearance, visibility of items, and safe storage."
    },
    {
      question: "What items can be stored?",
      answer:
        "It is ideal for storing utensils, jars, containers, and delicate kitchen items."
    }
  ]
},


  {
  code: "SM-06",
  name: "DARK GREY SLIM TANDEM BOX 350MM",
  category: "slim-box",

  mainImage: mainImg5,
  thumbnails: [thumb11, thumb12],

  short:
    "Dark Grey Slim Tandem Box 350mm is a compact drawer system designed for modern modular kitchens and furniture. Its sleek dark grey finish enhances the cabinet look, while the 350mm size makes it ideal for small and narrow spaces. The tandem sliding mechanism ensures smooth, silent, and controlled drawer movement for daily use.",

  features: [
    "350mm size perfect for compact cabinets",
    "Modern dark grey finish",
    "Slim side design for maximum storage space",
    "Smooth and silent tandem sliding mechanism",
    "Strong and durable metal construction",
    "Ideal for small drawers and modular furniture"
  ],

  // ✅ VIDEO (SAME EMBED)
  video: "https://www.youtube.com/embed/ikjQKXTpNhg",

  // ✅ PRICE
  price: "₹1728",
  oldPrice: "₹1800",

  sku: "7459-7461",
  stock: "In Stock",

  // ✅ BUTTONS
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Dark%20Grey%20Slim%20Tandem%20Box%20350mm%20Inquiry",

  // ✅ ADDITIONAL INFO (TABLE)
  specifications: [
    { label: "Length", value: "350mm" },
    { label: "Material", value: "Metal" },
    { label: "Finish", value: "Dark Grey" },
    { label: "Usage", value: "Drawer Storage" },
    { label: "Extension", value: "Full Extension" },
    { label: "Installation", value: "Drawer System" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "DARK GREY SLIM TANDEM BOX",
      code: "7459",
      size: "84mm",
      finish: "Dark Grey"
    },
    {
      item: "DARK GREY SLIM TANDEM BOX",
      code: "7460",
      size: "116mm",
      finish: "Dark Grey"
    },
    {
      item: "DARK GREY SLIM TANDEM BOX",
      code: "7461",
      size: "166mm",
      finish: "Dark Grey"
    },
    {
      item: "DARK GREY SLIM TANDEM BOX",
      code: "7424",
      size: "196mm",
      finish: "Dark Grey"
    },
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is a Dark Grey Slim Tandem Box 350mm?",
      answer:
        "It is a compact modular drawer system designed for slim drawers with a modern dark grey finish."
    },
    {
      question: "Where is it used?",
      answer:
        "It is used in kitchen drawers, cabinets, and modular furniture for organizing small items."
    },
    {
      question: "What are its advantages?",
      answer:
        "It saves space, provides smooth sliding, keeps items organized, and enhances drawer aesthetics."
    },
    {
      question: "What items can be stored?",
      answer:
        "It is ideal for storing cutlery, utensils, stationery, and small accessories."
    }
  ]
},


 {
  code: "SM-07",
  name: "PUSH OPEN QUADRO FOR WOODEN DRAWERS",
  category: "slim-box",

  mainImage: mainImg6,
  thumbnails: [thumb13, thumb14],

  short:
    "Push Open Quadro is a premium handle-less drawer mechanism designed for wooden drawers, allowing smooth and effortless opening with a simple push. It offers a clean, modern, and minimalist look while ensuring soft, silent, and precise drawer operation. Ideal for kitchens, wardrobes, and modular furniture.",

  features: [
    "Push-to-open mechanism for handle-less operation",
    "Smooth and effortless drawer opening",
    "Strong and durable construction for long-term use",
    "Soft push system prevents slamming and damage",
    "Ideal for kitchens, wardrobes, and modular furniture",
    "Enhances modern minimalist interior design"
  ],

  // ✅ VIDEO (same style embed)
  video: "https://www.youtube.com/embed/LUWqt-Nlp-o",

  // ✅ PRICE
  price: "₹1227",
  oldPrice: "1300",

  sku: "7731-7727",
  stock: "In Stock",

  // ✅ BUTTONS
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Push%20Open%20Quadro%20For%20Wooden%20Drawers%20Inquiry",

  // ✅ ADDITIONAL INFO (TABLE)
  specifications: [
    { label: "Type", value: "Push Open Mechanism" },
    { label: "Material", value: "Metal + Spring System" },
    { label: "Finish", value: "Standard Industrial Finish" },
    { label: "Usage", value: "Wooden Drawer System" },
    { label: "Operation", value: "Push to Open" },
    { label: "Installation", value: "Drawer Side Fitting" }
  ],

  // ✅ SPEC TABLE (variants if applicable)
  specTable: [
    {
      item: "PUSH OPEN QUADRO MECHANISM",
      code: "7731",
      size: "500mm/(20\")",
      finish: "Metal"
    },
     {
      item: "PUSH OPEN QUADRO MECHANISM",
      code: "7730",
      size: "450mm/(18\")",
      finish: "Metal"
    },
     {
      item: "PUSH OPEN QUADRO MECHANISM",
      code: "7729",
      size: "400mm/(16\")",
      finish: "Metal"
    },
     {
      item: "PUSH OPEN QUADRO MECHANISM",
      code: "7728",
      size: "350mm/(14\")",
      finish: "Metal"
    }, {
      item: "PUSH OPEN QUADRO MECHANISM",
      code: "7727",
      size: "300mm/(12\")",
      finish: "Metal"
    },
    
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is Push Open Quadro?",
      answer:
        "It is a handle-less mechanism that allows wooden drawers to open with a simple push."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is suitable for kitchens, wardrobes, cabinets, and modular furniture."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made with high-quality materials for long-lasting performance."
    },
    {
      question: "Does it prevent slamming?",
      answer:
        "Yes, the mechanism ensures smooth operation and avoids sudden slamming."
    },
    {
      question: "Is installation easy?",
      answer:
        "Yes, it can be easily installed in standard wooden drawer systems."
    }
  ]
},


  

{
  code: "SM-08",
  name: "3D QUADRO FOR WOODEN DRAWERS",
  category: "slim-box",

  mainImage: mainImg7,
  thumbnails: [thumb15, thumb16],

  short:
    "The 3D Quadro for Wooden Drawers is a precision-engineered drawer mechanism that provides three-dimensional adjustment for perfect alignment and smooth operation. Designed for modern wooden furniture, it allows easy leveling, soft closing, and reliable functionality. Ideal for kitchens, wardrobes, and storage units, it ensures flawless drawer performance with a sleek finish.",

  features: [
    "Ensures smooth and reliable operation for wooden drawers",
    "3D adjustment for perfect alignment and fitting",
    "Soft-close system prevents slamming and damage",
    "Durable mechanism for long-lasting performance",
    "Compatible with handle-less and traditional drawers",
    "Ideal for kitchens, wardrobes, and modular furniture"
  ],

  // ✅ VIDEO
  video: "https://www.youtube.com/embed/ikjQKXTpNhg",

  // ✅ PRICE
  price: "₹1209",
  oldPrice: "1300",

  sku: "7213",
  stock: "In Stock",

  // ✅ BUTTONS
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=3D%20Quadro%20For%20Wooden%20Drawers%20Inquiry",

  // ✅ SPECIFICATIONS
  specifications: [
    { label: "Type", value: "3D Adjustment Quadro" },
    { label: "Material", value: "Metal Mechanism" },
    { label: "Finish", value: "Industrial Finish" },
    { label: "Usage", value: "Wooden Drawer System" },
    { label: "Feature", value: "Soft Close + 3D Adjustment" },
    { label: "Installation", value: "Drawer Side Fitting" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "3D QUADRO FOR WOODEN DRAWERS",
      code: "7213",
      size: "500mm(20\")",
      finish: ""
    },
    {
      item: "3D QUADRO FOR WOODEN DRAWERS",
      code: "7212",
      size: "450mm(18\")",
      finish: ""
    },
    {
      item: "3D QUADRO FOR WOODEN DRAWERS",
      code: "7211",
      size: "400mm(16\")",
      finish: ""
    },
    {
      item: "3D QUADRO FOR WOODEN DRAWERS",
      code: "7543",
      size: "350mm(14\")",
      finish: ""
    },
    {
      item: "3D QUADRO FOR WOODEN DRAWERS",
      code: "7544",
      size: "300mm(12\")",
      finish: ""
    },
    {
      item: "3D QUADRO FOR WOODEN DRAWERS",
      code: "7732",
      size: "300mm(10\")",
      finish: ""
    },
    {
      item: "3D QUADRO FOR WOODEN DRAWERS",
      code: "7213",
      size: "550mm(22\")",
      finish: ""
    },
    {
      item: "3D QUADRO FOR WOODEN DRAWERS",
      code: "7683",
      size: "600mm(24\")",
      finish: ""
    },
    
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is 3D Quadro for Wooden Drawers?",
      answer:
        "It is a drawer mechanism with three-dimensional adjustment for smooth operation and perfect alignment."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is suitable for kitchens, wardrobes, cabinets, and modular furniture."
    },
    {
      question: "Does it support soft close?",
      answer:
        "Yes, it ensures soft closing to prevent slamming and protect furniture."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made with high-quality materials for long-lasting use."
    },
    {
      question: "Can it work with handle-less drawers?",
      answer:
        "Yes, it is compatible with both handle-less and traditional drawer systems."
    }
  ]
},

  


  

];
